/**
 * Magic-link / email notification `type` query values (`?type=`).
 * Keep labels in sync with backend notification templates when adding types.
 */
export const NotificationNext = {
  ProposeDates: '2',
  OpenTasks: '3',
  StageOrFeedback: '4',
  FeedbackDetail: '5',
  CandidateHistory: '6',
  Messages: '7',
  Job: '8',
  CandidatesSpecification: '9',
  ShowOffer: '10',
  InProcessCandidates: '11',
  RejectedFeedback: '12',
  ShowOfferAlt: '13',
  ClientTasksOrGuestDates: '14',
  RejectedFeedbackAlt: '15',
  RateInterview: '16',
  AdminJob: '17',
  InProcessAlt: '19',
} as const;
